import type { FaireProductEntity } from "../../entity_types/product";

export const p_3px76xekts: FaireProductEntity = {
  token: "p_3px76xekts",
  type: "product",
  name: "Guava Leave-In Conditioner",
  brandToken: "b_4240zqg5kc",
  brandName: "Ceremonia",
  imageUrl:
    "https://cdn.faire.com/fastly/5fc9a76145631c41c6eb6166ab0795b4f51f666db65adcce9a2bc3d42002c08d.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=960&width=720",
  priceDollars: 13.5,
  description: "Guava Leave-In Conditioner for wholesale.",
  tags: ["haircare"],
  caseSize: 6,
  msrpDollars: 27,
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-04-14T00:00:00.000Z",
    importedBy: "ceremonia-brand-prototype",
  },
  categoryTokens: [],
};
